/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetLowerthirdByDateQueryResponse, PntAppControllerGetLowerthirdByDatePathParams, PntAppControllerGetLowerthirdByDateQueryParams } from "../models/PntAppControllerGetLowerthirdByDate";

export function getPntAppControllerGetLowerthirdByDateUrl(slug: PntAppControllerGetLowerthirdByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/lowerthird` as const }
  return res
}

/**
 * @summary Retrieve the lowerthirds for a given time range
 * {@link /pnt/v2/segments/:slug/lowerthird}
 */
export async function pntAppControllerGetLowerthirdByDate(slug: PntAppControllerGetLowerthirdByDatePathParams["slug"], params: PntAppControllerGetLowerthirdByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerGetLowerthirdByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}